import React from 'react'
import styled from 'styled-components'
import { FormInputContainer, FormInputLabel } from '@appearance/styled'
import i18n from '@localization/i18n'

export default ({ text, label, width = '100%' }) => {
    return (
        <FormInputContainer lang={i18n.locale} width={width}>
            {label && (
                <FormInputLabel lang={i18n.locale}>{label}</FormInputLabel>
            )}
            <Text>{text}</Text>
        </FormInputContainer>
    )
}

const Text = styled.div`
    color: #222;
    min-height: 32px;
    font-weight: 600;
    padding: 4px 0px;
`
